import request from '@/utils/request'

//const serverURL = "https://vab-unicloud-3a9da9.service.tcloudbase.com";
//const apiURL = "/notice/getList";


// 删除运维
export function findList(params) {
  return request({
    url: '/staff/findList',
    method: 'get',
    params,
  })
}

// 获取操作日志
export function getLogList(params) {
  return request({
    url: '/staff/findLogList',
    method: 'get',
    params,
  })
}

// 获取运维列表
export function getMaintainStaffList(params) {
  return request({
    url: '/staff/findMaintainStaffList',
    method: 'get',
    params,
  })
}

// 新增运维
export function createMaintainStaff(data) {
  return request({
    url: '/staff/createMaintainStaff',
    method: 'post',
    data,
  })
}

// 删除运维
export function removeMaintainStaff(data) {
  return request({
    url: '/staff/removeMaintainStaff',
    method: 'post',
    data,
  })
}
